function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime/helpers/iterableToArray.js
 ** module id = 620
 ** module chunks = 0
 **/